import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc ca làm việc
export function locCaLamViec(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/ca-lam-viec/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy ca làm việc
export function layCaLamViec(id: number) {
  try {
    return axiosApi.get('/cham-cong/ca-lam-viec/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo ca làm việc
export function taoCaLamViec(params: any) {
  try {
    return axiosApi.post('/cham-cong/ca-lam-viec/', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật ca làm việc
export function capNhatCaLamViec(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/ca-lam-viec/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa ca làm việc
export function xoaCaLamViec(id: number) {
  try {
    return axiosApi.delete('/cham-cong/ca-lam-viec/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
